import BackgroundUrl from '@assets/backgrounds/suggestions-top_background.png';
import palette from '@lib/core/src/theme/palette';
import {
  Stack,
  styled,
  alpha,
  Typography,
  Select as MuiSelect,
  MenuItem as MuiMenuItem,
  Box
} from '@mui/material';

export const MenuItem = styled(MuiMenuItem)({
  padding: '6px 12px',
  minHeight: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontWeight: 400,
  fontSize: '14px',
  borderRadius: '8px',
  backgroundColor: 'white',
  border: 'none',
  boxShadow: 'none',
  outline: 'none',

  '&:hover': {
    backgroundColor: '#F5F7FF'
  },

  '&.Mui-selected': {
    backgroundColor: '#F5F7FF !important',
    fontWeight: 600,
    border: 'none',
    outline: 'none',
    boxShadow: 'none'
  },

  '&.Mui-selected:hover': {
    backgroundColor: '#F5F7FF !important',
    border: 'none',
    boxShadow: 'none'
  },

  '&:focus': {
    backgroundColor: '#F5F7FF',
    outline: 'none !important',
    border: 'none !important',
    boxShadow: 'none !important'
  },

  '&.Mui-focusVisible': {
    outline: 'none !important',
    border: 'none !important',
    boxShadow: 'none !important',
    backgroundColor: '#F5F7FF'
  }
});

export const Container = styled(Stack)({
  background: `url(${BackgroundUrl}) no-repeat center center`,
  backgroundSize: 'cover',
  padding: '12px',
  borderRadius: '8px'
});

export const AvatarAndTitle = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '11px'
});

export const Title = styled(Stack)({
  fontSize: '13px',
  fontWeight: '700',
  color: palette.white
});

export const Bubble = styled(Stack)({
  padding: '8px 12px',
  width: '100%',
  backgroundColor: alpha(palette.white, 0.2),
  borderRadius: '8px',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-8px',
    left: '12px',
    width: '0',
    height: '0',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderBottom: `8px solid ${alpha(palette.white, 0.2)}`
  },
  fontSize: '13px',
  fontWeight: '600',
  color: palette.white,
  lineHeight: '16px'
});

export const Select = styled(MuiSelect)({
  backgroundColor: alpha(palette.white, 0.2),
  borderRadius: '8px',
  height: '40px',
  color: palette.black,
  background: palette.white
});

export const SmallSelect = styled(Select)({
  width: '132px'
});

export const LargeSelect = styled(Select)({
  flexGrow: 1
});

export const Row = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '16px',
  gap: '16px'
});

export const UserSelectContainer = styled(Stack)({
  flexGrow: 1
});

export const TooltipBox = styled(Box)({
  maxHeight: '50vh',
  backgroundColor: palette.white,
  borderRadius: '8px',
  padding: '10px',
  overflow: 'auto',
  color: palette.black
});
